/*
 * @format
 * @flow
 */
import React from 'react';

type PropTypes = {
    links: [
        {
            url: string,
            title: string,
            description: string
        }
    ]
};

export default class AdditionalLinks extends React.Component<PropTypes> {
    render() {
        const { links } = this.props;
        if (!(links && links.length)) {
            return null;
        }

        const linkList = links.map((link) => (
            <li key={link.url}>
                <a href={link.url} rel="noopener noreferrer" target="_blank">
                    {link.description ? link.description : link.title}
                </a>
            </li>
        ));

        return (
            <div className="rec-aside-body rec-aside-box">
                <h5>Additional Information</h5>
                <ul className="additional-links">{linkList}</ul>
            </div>
        );
    }
}
